import { showDialog, getMsg, isNotEmpty, isNotUndefined } from "../../util/util";
import { focusBack } from "../../util/isd-utils";
import $ from 'jquery';
import authService from "./authService";
import dialogService from "./dialogService";
import sessionStore from "../../store/sessionStore";
import rootScope from "../../store/rootScopeStore";

/**
* 非同期通信共通処理(通常)
* 
*/
const async = (prms, thn, cth, fnly) => async (dispatch) => {
    // Promiseを返す
    asyncBase(prms, thn, cth, fnly, dispatch, false);
}

/**
* 非同期通信共通処理(バッチ)
* 
*/
const asyncBatch = (prms, thn, cth, fnly) => async (dispatch) => {
    // Promiseを返す
    asyncBase(prms, thn, cth, fnly, dispatch, true);
}

/**
* 非同期通信共通処理
* 
*/
const asyncBase = (prms, thn, cth, fnly, dispatch, isBatch) => {
    // ローディングマスク表示
    showDialog();
    // ローディングカウント追加
    sessionStore.loadingCnt = 1;
    rootScope.loading = true;

    // ローディングマスクが表示されている間キー入力を受け付けない
    $(window).on("keydown", (event) => {
        event.preventDefault();
    });
    const callPrms = (typeof prms === 'function') ? dispatch(prms) : prms;
    callPrms.then((response) => { // セッションタイムアウト
        if (response && response?.data.authFlg === "false") {
            // ログイン済みの場合セッションを終了させてログアウトする
            if (authService.isLogged()) {
                dispatch(authService.logout()).then((res) => {
                    // アラート表示後、ログイン画面へ戻す
                    dialogService.okDialog("EWEB0001", getMsg("EWEB0001"), null, () => {
                        window.location.reload();
                    });
                });
            }
            // サーバ側処理でシステムエラーが発生した場合
        } else if (response && isNotEmpty(response.data) && isNotEmpty(response.data.message) && response.data.message === rootScope.Message["EWEB9999"][0]) {
            // エラーダイアログ表示
            dialogService.okDialog(response.data.message, getMsg(response.data.message));
            console.error("サーバ側でエラー発生： " + response.stackTrace);

            // エラーメッセージが設定されている場合、正常終了コード以外
        } else if (response && isNotEmpty(response.data) && isNotEmpty(response.data.message) && response.data.message !== rootScope.Message["ICMN0010"][0]) {
            // エラー時のコールバック関数が設定されている場合、コールバック関数を呼び出す
            if (cth && isNotUndefined(response.data.result)) {
                cth(response.data);
                // 終了処理を実行
                asyncFinally(response, null);
                return;
            }
            // ビジネスリソース呼び出し時のエラーの場合（messageにmessageCodeが設定されている）
            if (/^\w{8}$/.test(response.data.message)) {
                dialogService.okDialog(response.data.message, getMsg(response.data.message), null);
                // 終了処理を実行
                asyncFinally(response, null);
                return;
            }
            const dispMsg = isNotEmpty(response.data.message) ? response.data.message : getMsg(response.data.messageCode);
            // コールバック関数の設定がない場合、エラーダイアログ表示
            dialogService.okDialog(response.data.messageCode, dispMsg, null, focusBack);

            // メンテナンスモードの場合
        } else if (response && response[228] === "さ") {
            // 再描画してメンテナンス画面を開く
            window.location.reload();
        } else {
            if (thn) {
                if (isBatch) {
                    // ローディングカウント削減
                    sessionStore.loadingCnt = 1;
                    // バッチ進捗状況監視
                    setTimeout(() => {
                        batchStatusCheck(dispatch, thn);
                    }, 1000);
                } else {
                    // コールバックを実行
                    thn(response.data);
                }
            }
        }
        // 終了処理を実行
        asyncFinally(response, null);
        // 例外発生時処理
    })["catch"]((response) => {
        // エラーダイアログ表示
        if (cth) {
            cth(response.data);
        } else {
            const msg = isNotEmpty(response) && isNotEmpty(response.data) ? response.data.message : "";
            dialogService.okDialog("EWEB0999", getMsg("EWEB0999") + "[" + msg + "]", null, focusBack);
        }
        /* デバッグ用ログ */
        console.log(isNotEmpty(response) ? (isNotEmpty(response.stackTrace) ? response.stackTrace : response) : "");
        asyncFinally(null, null);
    });


}

const batchStatusCheck = (dispatch, thn) => {
    // TODO logic
    // dispatch(CMN.cmna004({ tntocd: getTntocd(authService), gmnid: pageInfo.currentPage })).then(function (statusresponse) {
    //     // データが取得できなかった場合
    //     if (isEmpty(statusresponse.response)) {
    //         $timeout(function () {
    //             batchStatusCheck(dispatch, thn);
    //         }, 1000);
    //     } else {
    //         // ステータスが正常の場合は正常メッセージを設定
    //         if (statusresponse.response.logstatekbn == "2") {
    //             response.messageCode = "ICMN0010";
    //             response.message = getMsg("ICMN0010");
    //             response.status = kubunmap.STATUS.NORMAL.code;
    //         } else {
    //             // エラーの場合はエラーメッセージを設定
    //             response.messageCode = "ESYS0010";
    //             const messageParam = ["バッチ処理", "ログ確認画面でエラー内容を確認してください。"];
    //             // レスポンスのログ情報を解析してエラーコードが取得できた場合はそのエラーコードでログを出力する
    //             const splitInfo1 = statusresponse.response.loginfo.split("エラーコード：");
    //             if (splitInfo1.length > 1) {
    //                 const splitInfo2 = splitInfo1[1].split("\r\n");
    //                 if (splitInfo2.length > 1) {
    //                     response.messageCode = splitInfo2[0];
    //                     messageParam = [];
    //                 }
    //             }
    //             response.message = getMsg(response.messageCode, messageParam);
    //             response.status = kubunmap.STATUS.ERROR.code;
    //         }
    //         // コールバックを実行
    //         thn(response);
    //         // 終了処理を実行
    //         asyncFinally(response);
    //     }
    // });
}

const asyncFinally = (response, fnly) => {
    // ローディングカウント削減
    sessionStore.loadingCnt = -1;
    // ローディングマスク非表示
    if (sessionStore.loadingCnt <= 0) {
        sessionStore.loadingCnt = 0;
        rootScope.loading = false;
        showDialog('off');
        // ローディングマスク非表示のときキー入力を受け付ける
        $(window).off("keydown");
    }
    if (fnly) fnly(response);
}

const asyncService = {
    async,
    asyncBatch,
    asyncBase
}
export default asyncService;